import { forwardRef, memo, useEffect } from 'react';

import { BaseBoxProps } from '../interface';
import { TooltipArrowStyled } from './TooltipArrowStyled';
import { TooltipStyled } from './TooltipStyled';
import { TooltipContentProps } from './interface-tooltip';

export const TooltipContent = memo(
  forwardRef<HTMLDivElement, TooltipContentProps & BaseBoxProps>(
    ({ placement, children, onLoad, isLoaded, ...restProps }: TooltipContentProps, ref) => {
      useEffect(onLoad, [onLoad]);

      return (
        isLoaded && (
          <>
            <TooltipStyled {...restProps} placement={placement} ref={ref}>
              {children}
            </TooltipStyled>
            <TooltipArrowStyled placement={placement} />
          </>
        )
      );
    },
  ),
);

TooltipContent.displayName = 'TooltipContent';
